import * as React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import theme from '../theme';
import CssBaseline from '@mui/joy/CssBaseline';
export default function AppProviders({children}:{children:React.ReactNode}){
  React.useEffect(()=>{ const m=localStorage.getItem('theme'); if(m) document.documentElement.classList.toggle('dark', m==='dark'); },[]);
  return (<CssVarsProvider theme={theme} defaultMode='system'><CssBaseline />{children}</CssVarsProvider>);
}
